<template>
  <div class="tablet:fixed top-1/5 right-0 flex justify-center gap-2 items-center tablet:flex-col">
    <a :href="config.socials.instagram" class="text-white tablet:text-brand-dark p-2 hover:text-dark">
      <IconInstagram class="size-6" />
    </a>
    <a :href="config.socials.facebook" class="text-white tablet:text-brand-dark p-2  hover:text-dark">
      <IconFacebook class="size-6" />
    </a>
    <a :href="`tel:${config.contact.phone}`" class="text-white tablet:text-brand-dark p-2  hover:text-dark">
      <PhoneIcon class="size-6" />
    </a>
    <a :href="`mailto:${config.contact.email}`" class="text-white tablet:text-brand-dark p-2  hover:text-dark">
      <EnvelopeIcon class="size-6" />
    </a>
  </div>
</template>
<script setup lang="ts">
import { PhoneIcon, EnvelopeIcon  } from "@heroicons/vue/24/outline";

const config = useRuntimeConfig().public;
</script>